import { defineEntity, custom } from './_helpers.js';

export default defineEntity(
    'delegation',
    {
        created:    custom({ scope: 'access' }),
        accepted:   custom({ scope: 'access' }),
        declined:   custom({ scope: 'access' }),
        revoked:    custom({ scope: 'access' }),
        expired:    custom({ scope: 'access' }),
    },
    { includeDefaultLifecycle: false },
);
